document.addEventListener('DOMContentLoaded', initPincodeModalSystem);

function initPincodeModalSystem() {
  var modal = document.querySelector('[data-pk-pincode-modal]');
  if (!modal) return;

  var input = modal.querySelector('[data-pk-modal-input]');
  var checkBtn = modal.querySelector('[data-pk-modal-check]');
  var closeBtn = modal.querySelector('[data-pk-modal-close]');
  var errorEl = modal.querySelector('[data-pk-modal-error]');
  var backdrop = modal.querySelector('[data-pk-modal-backdrop]');
  var allowed = (modal.dataset.pincodes || '')
    .split(',')
    .map(function (c) { return c.trim(); })
    .filter(Boolean);

  var pendingForm = null;

  function isVerified() {
    try {
      var saved = JSON.parse(localStorage.getItem('pk_pincode') || 'null');
      return !!(saved && saved.ok);
    } catch (e) {
      return false;
    }
  }

  // function openModal(form) {
  //   pendingForm = form;
  //   errorEl.hidden = true;
  //   input.value = '';
  //   modal.hidden = false;
  //   document.body.classList.add('pk-modal-open');
  //   input.focus();
  // }

  // function closeModal() {
  //   modal.hidden = true;
  //   document.body.classList.remove('pk-modal-open');
  //   pendingForm = null;
  // }

  function openModal(form) {
    pendingForm = form;
    errorEl.hidden = true;
    input.value = '';
    modal.hidden = false;
    document.body.classList.add('pk-modal-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('pk-modal--visible');
        input.focus();
      });
    });
  }

  function closeModal() {
    modal.classList.remove('pk-modal--visible');
    document.body.classList.remove('pk-modal-open');
    setTimeout(function () {
      modal.hidden = true;
    }, 280);
    pendingForm = null;
  }

  function handleCheck() {
    var value = (input.value || '').trim();
    if (!/^\d{6}$/.test(value)) {
      errorEl.textContent = 'Enter a valid 6-digit pincode.';
      errorEl.hidden = false;
      return;
    }

    var ok = allowed.indexOf(value) !== -1;
    try {
      localStorage.setItem('pk_pincode', JSON.stringify({ pincode: value, ok: ok }));
    } catch (e) {}

    if (ok) {
      var formToSubmit = pendingForm;
      closeModal();
      if (formToSubmit) {
        formToSubmit.setAttribute('data-pk-bypass', 'true');
        if (formToSubmit.requestSubmit) {
          formToSubmit.requestSubmit();
        } else {
          formToSubmit.submit();
        }
      }
    } else {
      errorEl.textContent = modal.dataset.failMsg;
      errorEl.hidden = false;
    }
  }

  checkBtn.addEventListener('click', handleCheck);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleCheck();
    }
  });
  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target.closest('[data-pk-gated-form]');
      if (!form) return;

      if (form.getAttribute('data-pk-bypass') === 'true') {
        form.removeAttribute('data-pk-bypass');
        return;
      }

      if (isVerified()) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      openModal(form);
    },
    true
  );
}